import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IVerifyMultipleCollaborators } from '../../../../models/collaboration/IVerifyMultipleCollaborators';
import { CONSTANTS } from '../../../../Constants/Constants';


@Component({
    selector: 'app-verify-collaborators-dialog',
    templateUrl: './verify-collaborators-dialog.component.html',
    styleUrls: ['./verify-collaborators-dialog.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslatePipe,
        MatButtonModule,
        MatDialogActions,
        MatDialogClose,
        MatDialogTitle,
        MatDialogContent
    ]
})
export class VerifyCollaboratorsDialogComponent implements OnInit {
    message: string = "";
    constructor(
        public dialogRef: MatDialogRef<VerifyCollaboratorsDialogComponent>,
        private readonly translate: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data: IVerifyMultipleCollaborators
    ) {}

    ngOnInit(): void {
        this.data = this.data || { collaborators: [], availableCollaborators: [] };
        this.buildErrorMessage();
    }

    // README: Logic is working but needs refinement, will continue working on the same and remove all harcoded strings and placeholders
    private buildErrorMessage(): void {
        const invalidCollaboratorsList = this.createInvalidCollaboratorsList();
        const invalidAvailableCollaboratorsList = this.createInvalidAvailableCollaboratorsList();

        if(this.data.collaborators.length && this.data.availableCollaborators.length){
            const baseMessage = this.translate.instant("INVALID_COLLABORATORS_ERROR_MESSAGE", {
                invalidCollaborators: "placeholder",
                invalidAvailableCollaborators: "placeholder"
            });
            this.message = this.formatErrorMessage(baseMessage, invalidCollaboratorsList, invalidAvailableCollaboratorsList);
        } else if(this.data.availableCollaborators.length){
            const baseMessage = this.translate.instant("INVALID_AVAILABLE_COLLABORATORS_ERROR_MESSAGE", {
                invalidAvailableCollaborators: "placeholder"
            });
            this.message = this.formatErrorMessage(baseMessage, null, invalidAvailableCollaboratorsList);
        } else {
            const baseMessage = this.translate.instant("INVALID_ACTIVE_COLLABORATORS_ERROR_MESSAGE", {
                invalidCollaborators: "placeholder"
            });
            this.message = this.formatErrorMessage(baseMessage, invalidCollaboratorsList, null);
        }
    }

    private formatErrorMessage(baseMessage: string, collaborators: string | null, availableCollaborators: string | null): string {
        let message = baseMessage;
        if(collaborators) {
            message = message.replace("{invalidCollaborators}", `<br>${collaborators}<br><br>`);
        }
        if(availableCollaborators) {
            message = message.replace("{invalidAvailableCollaborators}", `<br>${availableCollaborators}<br><br>`);
        }
        // Add line break before the final sentence
        message = message.replace("Please check", "<br>Please check");
        return message;
    }

    createInvalidCollaboratorsList(): string {
        return this.data.collaborators.map(c => CONSTANTS.HYPHEN + CONSTANTS.SPACE + c.name).join("<br>");
    }

    createInvalidAvailableCollaboratorsList(): string {
        return this.data.availableCollaborators.map(c => CONSTANTS.HYPHEN + CONSTANTS.SPACE + c.name).join("<br>");
    }

}
